var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.164,
    d: "M25.097 11.636c.231.159-5.403 7.48-12.048 7.48S1 11.636 1 11.636s5.403-7.48 12.049-7.48c6.645 0 12.28 7.639 12.048 7.48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.164,
    d: "M13.092 15.245a3.603 3.603 0 1 0 0-7.207 3.603 3.603 0 0 0 0 7.207M12.514.831v3.27M1 6.744l1.515 2.561M6.15 2.249l.91 3.034M18.876 2.249l-.91 3.034M24.027 5.913l-1.515 2.56"
  })));
};
export default SvgEyeOpen;